import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import parse from 'html-react-parser';

import { roomSizeStatic } from '../../static-data/productStatic';
import { SUPPORTED_REGIONS } from '../../../shared/enums';

const faqs = [
  {
    title: 'Does Mila really work?',
    description: size => (
      <>
        <p>
          Yes! The Mila with Critter Cuddler filter is proven to circulate fresh
          air in a
          {' '}
          {size}
          {' '}
          space every 30 minutes. Mila is the first air purifier
          that shows you proof you can see, and you can always tell how long
          it'll take to achieve your target AQI (usually zero) either on the
          Mila display or in Mila's fan favorite app.
        </p>
        <p>
          Unlike most air purifiers out there, Mila also comes with seven
          customizable filters, each designed to do a specific job well. In the
          case of the Critter Cuddler filter, you can count on it to help filter
          out particulates with its H13 HEPA filter, eliminate pet odors and
          tackle VOCs with a special carbon blend especially designed to remove
          ammonia.
        </p>
      </>
    ),
  },
  {
    title: 'What is Mila\'s return policy?',
    description: () => (
      <p>
        Each Mila is backed by our Mila-backed guarantee. If you don’t love
        Mila, you can return her within 30 days for a full refund, minus
        shipping and handling. Plus, you'll always get a one year warranty and
        access to our award-winning customer care.
      </p>
    ),
  },
  {
    title: 'Does Mila emit ozone?',
    description: () => (
      <p>
        Mila emits zero ozone and we also don't recommend any air purifiers that
        do as they typically can cause more harm than good. Mila relies solely
        on mechnaical filtration and is also certified by the California Air
        Review Board (CARB) which stipulates how much ozone any product can
        release into the environment to make sure it's safe.
      </p>
    ),
  },
  {
    title: 'How does Auto-Refill work?',
    description: () => (
      <p>
        Auto-Refill makes swapping filters a cinch with a fresh set of filters
        delivered to you automatically every six months. Never miss a filter
        swap again and keep your air running in top condition. Swap, cancel,
        skip, or pause your Auto-Refill at any time.
      </p>
    ),
  },
  {
    title: 'When will my orders ship?',
    description: () => (
      <p>
        All orders ship the same or next business day with an average delivery
        timeline of about 3-5 days across the US, Canada, UK, Australia, and
        select EU countries (our average shipping time is 3.1 days to be exact).
      </p>
    ),
  },
];

const ProductFaqs = ({ localization, type }) => {
  const [ currentIndex, setCurrentIndex ] = useState(null);
  const { region } = localization;
  const regional = SUPPORTED_REGIONS[region] || SUPPORTED_REGIONS.US;

  const size = roomSizeStatic[type][regional].filter;

  return (
    <div className='product-faqs' style={{ '--primary-color': '#F42C52' }}>
      <div className='container container--md'>
        <div className='product-faqs__card'>
          <h2 className='product-faqs__title'>Have a Q? Find your A below.</h2>
          <div className='product-faqs__list'>
            {faqs.map(({ title, description }, idx) => (
              <div
                className={`product-faqs__item${
                  currentIndex === idx ? ' product-faqs__item--current' : ''
                }`}
                key={title}
              >
                <div
                  className='product-faqs__header'
                  onClick={() => setCurrentIndex(idx !== currentIndex ? idx : null)}
                >
                  <h3 className='product-faqs__item-title'>{title}</h3>
                  <svg className='icon icon-down-arrow-thin'>
                    <use xlinkHref='#icon-down-arrow-thin' />
                  </svg>
                </div>
                <AnimatePresence>
                  <motion.div
                    className='product-faqs__body'
                    initial={{ height: 0 }}
                    animate={{ height: currentIndex === idx ? 'auto' : 0 }}
                    transition={{ duration: 0.3 }}
                    style={{ overflow: 'hidden' }}
                  >
                    <div className='product-faqs__body-inner'>
                      {description(parse(`${size}`))}
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductFaqs;
